import { Box, InputLabel, Typography, Rating } from "@mui/material";
import React, { useEffect, useState } from "react";
import noImage from "../../assets/no-image.png";

const ProductsCardMansory = ({
  image,
  images,
  title,
  price,
  ratings,
  description,
  border,
  
}) => {
  return (
    <>
      <Box
        sx={{
          bgcolor: "#fff",
          borderRadius: "8px",
          cursor: "pointer",
          overflow: "hidden",
          boxSizing: "border-box",
          transition: "0.2s all linear",
          p: 1,
          border:border && "2px solid #7B408C",
          width:'100%',

          "&:hover": {
            boxShadow:
              "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
          },
        }}
      >
        <Box>
          <img
            srcSet={`${image || noImage}?w=162&auto=format&dpr=2 2x`}
            src={`${image || noImage}?w=162&auto=format`}
            alt={title}
            loading="lazy"
            style={{
              borderBottomLeftRadius: 4,
              borderBottomRightRadius: 4,
              display: "block",
              width: "100%",
              borderRadius:'4px'
            }}
          />

          {/* </Box> */}

          <Box sx={{ pb: 1, mt:1 }}>
            <InputLabel
              variant="caption"
              sx={{ fontSize: "14px", fontWeight: 400, color: "#1a1a1a" }}
            >
              {title}
            </InputLabel>
            <Typography
              variant="caption"
              className="three-line-ellipsis"
              sx={{
                fontSize: "10px",
                fontWeight: 300,
                color: "#1a1a1a",
                mt:0.5,
                lineHeight:'12px'
              }}
            >
              {description}
            </Typography>

            <Typography
              sx={{ color: "#333", fontSize: "16px", fontWeight: 500, mt: 0.2 }}
            >
              <span style={{ fontSize: "14px", marginRight: "1px" }}>
                &#36;
              </span>
              {price.toLocaleString()}
            </Typography>
            {/* <CurrencyDisplay amount={price.toLocaleString()}/> */}
            <Rating
              value={parseFloat(ratings)}
              readOnly
              size="small"
              sx={{ fontSize: "12px", color: "#df7922" }}
              precision={0.5}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default ProductsCardMansory;

const RenderCarousel = ({ images, title }) => {
  const [currentAdIndex, setCurrentAdIndex] = useState(0);
  const [slideClass, setSlideClass] = useState("slide-in-from-right");

  useEffect(() => {
    const interval = setInterval(() => {
      setSlideClass("slide-out-to-left");
      setTimeout(() => {
        setCurrentAdIndex((prevIndex) => (prevIndex + 1) % images.length);
        setSlideClass("slide-in-from-right");
      }, 500);
    }, 5000);

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div style={{ height: "150px", position: "relative", overflow: "hidden" }}>
      <Box
        className={`absolute w-full h-full transition-transform duration-500 ease-in-out ${slideClass}`}
        sx={{
          backgroundImage: `url(${images[currentAdIndex]})`,
          width: "100%",
          height: "100%",
          backgroundSize: "cover",
          backgroundPosition: "center",
          borderRadius: "8px",
        }}
      />
    </div>
  );
};
